// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__1nK3M","info":"Note_info__VVB1d","note":"Note_note__3NG9I","actions":"Note_actions__R_W9B"};